// Check build env, default to development
const buildEnv = ['production', 'staging', 'development'].includes(process.env.NODE_ENV || 'development')
    ? process.env.NODE_ENV
    : 'development';

// development.ts, staging.ts or production.ts
// eslint-disable-next-line import/no-dynamic-require
const appEnv = require(`./${buildEnv === 'development' ? 'development' : 'env'}.ts`).default;
const defaultProtocol = appEnv.environment === 'development' && !(appEnv?.forceHttps || false) ? 'http://' : 'https://';
export default {
    appEnv,
    defaultLocale: 'en-GB',
    appUrl: `${defaultProtocol}${appEnv.appHostname}`,
    ssoV1Url: `${defaultProtocol}${appEnv.ssoV1Hostname}`,
    ssoV2Url: `${defaultProtocol}${appEnv.ssoV2Hostname}`,
    graphqlUrl: `${defaultProtocol}${appEnv.graphqlGatewayHostname}`,
    luminaOpenBadgesClientUrl: `${defaultProtocol}${appEnv.luminaOpenBadgesClientHostname}`,
    luminaOnlineUrl: `https://${appEnv.luminaOnlineHostname}`,
    luminaFinanceUrl: `${defaultProtocol}${appEnv.financeHostname}`,
    luminateamsUrl: `${defaultProtocol}${appEnv.teamsHostname}`,
    luminaAtsUrl: `${defaultProtocol}${appEnv.AtsHostname}`,
    luminaELearingsUrl: `${defaultProtocol}${appEnv.eLearningHostname}`,
    openApiUrl: `https://${appEnv.openApiHostname}/v1`,
    luminaGetQualifiedUrl: `${defaultProtocol}${appEnv.luminaGetQualifiedUrlHostname}`,
    participantProjectPaginationLimit: appEnv.participantProjectPaginationLimit as number,
    projectAndSearchPaginationLimit: appEnv.projectAndSearchPaginationLimit as number,
    joinQualificationUrl: 'https://luminalearning.com/lumina-learning-events/?tabs=qualifications',
    luminaSupportSupportUrl: 'https://support.luminalearning.com',
    luminaGlobalSupportUrl: 'https://luminalearning.com/global-network/',
    hubspotBookMeetingUrl: 'https://meetings.hubspot.com/tal-sayegh/partner-sa-support-enquiry',
    brandfolderUrl: 'https://brandfolder.com/lumina-learning/',
    luminaLearningUlr: 'https://luminalearning.com/',
    billingAndPaymentUlr: 'https://luminalearning.com/contact-us-billing-payments/',
    sparkUpWorkshopLocales: [
        { locale: 'en-GB', prefix: '' },
        { locale: 'ja-JP', prefix: 'ja' },
        { locale: 'da-DK', prefix: 'da' },
        { locale: 'fr-FR', prefix: 'fr' },
        { locale: 'pl-PL', prefix: 'pl' },
    ],
    sparkUpCoachingLocales: [
        { locale: 'en-GB', prefix: '' },
        { locale: 'ja-JP', prefix: 'ja' },
        { locale: 'da-DK', prefix: 'da' },
        { locale: 'fr-FR', prefix: 'fr' },
        { locale: 'pl-PL', prefix: 'pl' },
    ],
    auth0: {
        domain: 'auth0.luminalearning.com',
        clientId: '2Quy521KVvQuU9zSMIDto64VyphP7fnW',
        scope: 'openid name nickname picture updated_at email https://sso.luminalearning.com/claims',
        clientSecret: 'TNCqEsjMqxCpYTdhUOK6wVJoM_h7zGxl_ZT6-XNTMkpOChkt_LPZ7Q9s4XQ1BJOr',
    },
    keycloak: {
        serverUrl: `${defaultProtocol}${appEnv.keycloakServerUrl}`,
        realm: 'lumina-sso',
    },
};
